import { render } from "./RegisterConfirmed.vue?vue&type=template&id=5137f5d4&scoped=true"
import script from "./RegisterConfirmed.vue?vue&type=script&lang=js"
export * from "./RegisterConfirmed.vue?vue&type=script&lang=js"

import "./RegisterConfirmed.vue?vue&type=style&index=0&id=5137f5d4&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5137f5d4"]])

export default __exports__